import {Grid, Typography, useReachGoalCallback} from '@logistics-frontend/blocks'
import React, {useCallback} from 'react'

import {PromoBannerButton, useDownloadAppCallback} from '../promo-banner-button/'
import {BannerView, METRIKA_GOALS} from '../PromoBanner.consts'
import {classes} from './PromoBannerWithoutLeadButton.classes'
import {Props} from './PromoBannerWithoutLeadButton.types'

export const Base: React.FC<Props> = ({title, trail_button}) => {
  const reachGoalCallback = useReachGoalCallback()

  const getApplicationCallback = useDownloadAppCallback(BannerView.WITHOUT_LEAD_BUTTON, trail_button?.deeplink)

  const onClick = useCallback(() => {
    reachGoalCallback(METRIKA_GOALS.INSTALL_BANNER_WO_PROMO_CLICK)
    getApplicationCallback()
  }, [getApplicationCallback, reachGoalCallback])

  return (
    <div className={classes.root} onClick={onClick}>
      <Grid alignItems="center" size="m" wrap="nowrap" container>
        <Grid container item>
          <Typography group="tight" thickness="medium" variant="caption1">
            {title}
          </Typography>
        </Grid>
        <Grid item>
          <PromoBannerButton {...trail_button} bannerView={BannerView.WITHOUT_LEAD_BUTTON} />
        </Grid>
      </Grid>
    </div>
  )
}

export const PromoBannerWithoutLeadButton = React.memo(Base)
